/**
 * 일지 오더목록 카드 렌더러 (JS) — 서버가 주던 카드 HTML 을 대체하는 클라이언트 렌더러.
 *
 * 서버 라우트(DiaryController@dayList/dayOrders → DiaryDayListService/DiaryCalendarDayService)가 주는
 * rows(카드별 buildRow 데이터)로 카드 DOM 문자열을 만든다. 비즈니스 규칙(금액변경가능·타본사·
 * 주소마스킹·발주수주 빨강처리 등)은 서버(buildRow)가 이미 판정해 데이터로 넘겨주므로,
 * 여기서는 순수 템플릿팅만 한다.
 *
 * 산출 DOM 은 레거시 서버렌더와 (공백 정규화 기준) 동치라, 기존 Pages/Mobile/Diary/Main.js 등 소비 JS 가
 * 읽는 속성(rsno·smode·otype·data-type·onclick 등)이 그대로 유지된다.
 *
 * 검증: tests/js/diary-list-renderer-parity (PHP 뷰 출력 vs 이 렌더러 출력 카드단위 대조).
 *
 * node(테스트)·브라우저(window.$j.F.DiaryList) 양쪽에서 쓰도록 UMD 로 노출한다.
 */
(function (factory) {
    var api = factory();
    if (typeof module !== 'undefined' && module.exports) module.exports = api;
    if (typeof window !== 'undefined') {
        window.$j = window.$j || {};
        window.$j.F = window.$j.F || {};
        window.$j.F.DiaryList = api;
    }
})(function () {
    'use strict';

    // 상수 HTML 조각 (구 buildRow 가 만들던 것 — 행별 데이터가 없어 여기 상수로).
    var PST_ICON = "<span class='cir20' style='width:19px !important ; height:19px  !important  ; -webkit-border-radius:15px;border-radius:15px; padding:0px; text-align:center;color:#FFFFFF; background-color:var(--diary-sel-on-bg); display:inline-block;font-size:12px;line-height:20px;'>발</span>";
    var ADR_CH_BTN = "<div class='changeAddrr' style='width:40px; display:none; float:right; font-size:15px;border-bottom: 3px solid var(--diary-accent);text-align:center;' id='addrchangebtn' onclick=\"modalMap(this)\">변경</div>";
    var CK_BTN = "onclick=\"naviCallTo()\" ";

    // 순수 CSS 상수 (구 buildRow 가 계산하던 값 — 행별 변화가 없어 여기 상수로).
    // 색은 var(--diary-*) 로 낸다 — 인라인 style 도 body[data-page-name='Diary'] 의 토큰을 상속받아
    // 다크에서 같이 뒤집힌다 (pages/_diary.scss).
    var TBC = 'var(--diary-cell-border)';
    var BD_R_XB = ';border-right:1px solid var(--diary-border);';
    var TR_HEIGHT = "style='height:30px'";
    var SSSTYLE = '';
    var STYLE_X001 = "font-size:15px;color:var(--diary-ink);letter-spacing:0px;padding-left:5px; font-weight:normal;border-right:1px solid var(--diary-cell-border);border-bottom:1px solid var(--diary-cell-border);";
    var STYLE_X0011 = "font-size:15px;color:var(--diary-ink);letter-spacing:0px;padding-left:5px; font-weight:normal;";
    var STYLE_X002 = "width:15px;display:inline-block; margin:0px; padding: 0px 0px; display:none";
    var STYLE_X003 = "border-bottom:1px solid var(--diary-cell-border);border-right:1px solid var(--diary-cell-border);white-space: nowrap;overflow: hidden;text-overflow: ellipsis;";
    var STT = "border-bottom:1px solid var(--diary-cell-border);text-align:left;letter-spacing:-1px;font-size:15px;border-left:1px solid ;padding-left:5px;vertical-align:top;padding-top:5px";

    // PHP `<?=$v?>` echo 의미론: true→"1", false/null/undefined→"", 그 외→문자열.
    function ev(v) {
        if (v === true) return '1';
        if (v === false || v === null || v === undefined) return '';
        return String(v);
    }

    // 회원이 입력한 값(현장주소·차량번호 등)을 마크업·속성에 넣을 때 — ev 에 HTML 이스케이프(따옴표 포함)를 더한다
    function eh(v) {
        return ev(v).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    // onclick="f('…')" 안의 JS 문자열 인자 — JS 이스케이프 뒤 HTML 이스케이프 (속성은 디코딩된 뒤 JS 로 읽힌다)
    function ejs(v) {
        return eh(ev(v).replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/[\r\n]/g, ' '));
    }

    // Rs 필드의 null/undefined → '' (PHP echo 는 null 을 "" 로 낸다).
    function nz(o) {
        var r = {};
        for (var k in o) {
            if (Object.prototype.hasOwnProperty.call(o, k)) {
                var v = o[k];
                r[k] = (v === null || v === undefined) ? '' : v;
            }
        }
        return r;
    }

    // 행 배경색(구 buildRow $stth). order_status·is_paid 로 계산, 미지급/미수는 서버 플래그로.
    function computeStth(R, mode) {
        if (mode === 'misupgeum') return ';background-color:var(--diary-row-misupgeum);color:var(--diary-ink);';
        if (mode === 'misu') return ';background-color:var(--diary-row-misu);color:var(--diary-ink)';
        var st = parseInt(R.order_status, 10);
        var wp = parseInt(R.is_paid, 10);
        var c = ';background-color:var(--diary-row-wait);';
        if (st === 6) c = ';background-color:var(--diary-row-st6);';
        else if (st < 6) c = ';background-color:var(--diary-row-pre);';
        else if (st === 7) c = ';background-color:var(--diary-row-st7);';
        else if (st === 8 && wp !== 1) c = ';background-color:var(--diary-row-wait);';
        else if (st === 99) c = ';background-color:var(--diary-row-cancel);';
        if (wp === 1) c = ';background-color:var(--diary-row-wp);';
        else if (st === 9 && wp !== 1) c = ';background-color:var(--diary-row-done);';
        return c;
    }

    /**
     * 진행바 표시값 — 최초 렌더(아래)와 폴링 갱신(ProgressBar.js)이 같은 규칙을 쓰도록 한 곳에 모은다.
     * order_status 4(수주대기) 이상이면 알림 자체가 끝난 것이라 단계와 무관하게 100% 로 본다.
     */
    function progressView(now, all, status) {
        all = parseInt(all, 10) || 0;
        now = parseInt(now, 10) || 0;
        if (all < 1) all = 1;
        if (now < 0) now = 0;
        var done = (parseInt(status, 10) || 0) >= 4 || now >= all;
        if (done) now = all;
        return {
            pct: Math.round(now * 1000 / all) / 10,
            // 눈금이 칸당 10px 미만으로 촘촘해지면 줄무늬로 보인다 → 매끈한 바(단계 수는 캡션이 알려준다)
            cls: (all > 34 ? ' jbpg--dense' : '') + (done ? ' jbpg--done' : ''),
            cap: '<b>' + now + '</b> / ' + all + ' 단계 ' + (done ? '알림 완료' : '알림중'),
        };
    }

    /**
     * 발주 진행바 최초 렌더 (show_statusBar==1 일 때만). 갱신은 F/Diary/ProgressBar.js 가 이어받는다.
     *
     * 구 방식은 단계마다 <input type=button> 을 한 칸씩 깔았는데, 전역 box-sizing 이 없어
     * 칸마다 테두리·UA padding 이 폭에 더해져 단계가 많으면(31칸 → +434px) 잘려 나갔다.
     * → 트랙 1개 + 채움(width %) 1개. 단계 구분은 CSS 눈금(--jbpg-steps)이 대신한다.
     * 마크업/클래스 규칙은 pages/_diary.scss .jbpg 참조.
     */
    function progressBar(row, R) {
        if (String(row.show_statusBar) !== '1') return '';
        var all = parseInt(row.tdMax, 10) || 0;
        if (all < 1) all = 1;
        var now = parseInt(R.group_now, 10) || 0;
        var pg = progressView(now, all, R.order_status);

        return '<div class="' + row.ea_ccLast + '">'
            + '<div class="jbpg' + pg.cls + '" id="prder_proceed_status_' + R.num + '"'
            + ' data_cd="' + R.num + ',' + R.order_status + ',' + R.group_now + ',' + R.group_all + ',0,0">'
            + '<div class="jbpg-bar" style="--jbpg-steps:' + all + '">'
            + '<span class="jbpg-fill" style="width:' + pg.pct + '%"></span>'
            + '</div>'
            + '<div class="jbpg-cap">' + pg.cap + '</div>'
            + '</div></div>';
    }

    /** 카드 한 장. 원본 diary-list-row.php 와 1:1. */
    function renderCard(row) {
        if (row && row.nono !== undefined) return "<div id='nono'>" + row.nono + "</div>";
        var R = nz(row.Rs);
        var num = R.num;

        // showLine != 1 → 숨김 마커 div (원본 else 절)
        if (String(row.showLine) !== '1') {
            return "<div id='notmatcheddiv' style='display:none' smode='" + row.smode + "'  dass='안보이게설정' rsno='" + num
                + "' otype='" + row.orsType + "' smodeSet='" + row.smodeSet + "' showmode='" + row.showmode
                + "' showLine='" + row.showLine + "' howpay='" + (parseInt(R.pay_method, 10) || 0)
                + "' showBalSign='" + row.showBalSign + "' addr='" + eh(R.site_address) + "'></div>";
        }

        var easyCol = (row.jobisdone === 'easy') ? ' colspan=2' : '';

        // 구 buildRow 가 만들던 조각들을 데이터/플래그로 받아 여기서 조립.
        var stChangeTag = row.hideStChangeTag ? '' : 'data-type="dateChangeSpan"';
        var priceBtn = row.isPriceChange
            ? 'onclick="car_price_Change(' + num + ', ' + row.smode + ',event)"'
            : 'onclick="alert(\'금액변경 불가능합니다. 사무실로 문의해 주세요\')"';

        // 상세보기 onclick (구 buildRow $ClickJob). 모드 인자(clickJobArg)만 서버가 준다.
        var clickJob = "showDetailTable(" + num + ",'" + row.Sttx + "', event,'" + row.jobisdone + "'," + row.clickJobArg + ")";

        // 상태 라벨 tty 의 강조 마크업 (구 buildRow 에서 이관 — 텍스트는 서버, bold/red 는 여기).
        var ttyHtml = row.ttyStyle === 'bold' ? '<b>' + ev(row.tty) + '</b>'
            : row.ttyStyle === 'red' ? "<font style='color:var(--diary-sun)'>" + ev(row.tty) + '</font>'
            : ev(row.tty);

        var stth = computeStth(R, row.stthMode);

        // 결제방식 표시 (구 buildRow $howtopay). 라벨은 서버, 환원됨/만기 <font> 부가표시는 여기.
        var howtopayHtml = row.howtopayWhan
            ? "<font style='color:var(--diary-ink); font-size:13px'>" + ev(row.howtopay) + '</font>'
            : ev(row.howtopay);
        if (row.howtopayAnno) {
            howtopayHtml += "<font style='color:" + row.howtopayAnnoColor + "; font-size:12px'>" + ev(row.howtopayAnno) + '</font>';
        }

        // TabA 화면표시 라벨 (수주/발주 빨강처리·접수완료 치환). 구 buildRow $TabA_StrShown 과 동일.
        var tabAShown;
        if (row.tabAShownMode === 'received') {
            tabAShown = '접수완료';
        } else if (row.tabAShownMode === 'red-sujoo') {
            tabAShown = eh(row.TabA_Str).split('수주').join("<font style='color:var(--diary-sun)'>수주</font>");
        } else if (row.tabAShownMode === 'red-baljoo') {
            tabAShown = eh(row.TabA_Str).split('발주').join("<font style='color:var(--diary-sun)'>발주</font>");
        } else {
            tabAShown = eh(row.TabA_Str);
        }

        // 차량번호 배지 (black/white/hidden). 구 buildRow 3변형과 동일.
        var carNumBox = '';
        if (row.carNumMode !== 'hidden') {
            var cnStyle = (row.carNumMode === 'white')
                ? "z-index:9;width:18px !important ; height:18px  !important  ; -webkit-border-radius:15px;border-radius:15px; padding:0px; text-align:center;color:var(--diary-ink); border:1px solid var(--diary-border); background-color:var(--diary-surface); display:inline-block;font-size:14px;line-height:15px;"
                : "z-index:9;width:18px !important ; height:18px  !important  ; -webkit-border-radius:15px;border-radius:15px; padding:0px; text-align:center;color:var(--diary-surface); background-color:var(--diary-ink); display:inline-block;font-size:13px;line-height:20px;";
            carNumBox = "<span  class='cir20' style='" + cnStyle + "' onclick=\"show_carNumDetail("
                + num + ", '" + ejs(row.carNumShown) + "' , '" + ejs(row.carNumPlate) + "' , '" + ev(R.order_status)
                + "' , this,event)\">" + eh(row.carNumShown) + "</span>";
        }

        // 네비 + 주소 (juso_show 로 마스킹 분기)
        var addrCell = row.juso_show
            ? '<div dvxd=6 style="' + STYLE_X002 + '; z-index:99" id="eanaviBtn_' + num + '" data-type="NaviBtnbox">'
                + '<img src="/img/m/gpsicon_w190.png" id="GPSBTNICON" style="height:25px;vertical-align:bottom" ' + CK_BTN + '>'
                + '</div>'
                + '<span dvxd=7 class="txxd7" id="ea_addressinside' + num + '" data-gps="' + row.GPS1 + ',' + row.GPS2 + '" data-addr="' + eh(R.site_address) + '" smode="' + row.smode + '" >' + eh(row.jobAddress) + '</span>'
            : '<span dvxd=7 class="txxd7" id="ea_addressinside' + num + '" data-gps="0,0" data-addr="' + eh(R.site_address) + '" smode="' + row.smode + '" >' + eh(row.jobAddressMasked) + '</span>';

        // 금액 표시 span (타본사 분기)
        var priceSpan = row.priceIsSosokJbbuller
            ? '<span ' + stChangeTag + ' id="changePriceSpan" canChangeDateTime="' + ev(row.isPriceChange) + '"  cdx=1  chcnt="">' + row.PP_fmt + '</span>'
            : '<span ' + stChangeTag + ' id="changePriceSpan" canChangeDateTime="' + ev(row.isPriceChange) + '" ' + SSSTYLE + " dd='" + row.infosxta + "' PP_job_type=\"" + row.PP_job_type + '" PP_car_workhour="' + row.PP_car_workhour + "\" stpp='" + row.stpp + "' cdx=" + R.car_price + '>' + row.PP_fmt + '</span>';

        // 결제방식 셀 (easy 아니면)
        var payCell = '';
        if (row.jobisdone !== 'easy') {
            payCell = row.howtopayChangable
                ? '<td txdcd=51 style="; text-align:left;padding-left:5px;font-size:15px;border-bottom:1px solid ' + TBC + ';" onclick="soojooPeeChangeDo(' + num + ',' + R.pay_method + ', ' + R.sign_days + ');" >'
                    + '<span data-type="dateChangeSpan" id="soojooPeeChange"  canChangeDateTime="' + ev(row.canChangeDateTime) + '" style="text-decoration:none; border-bottom:3px solid var(--diary-accent)">' + howtopayHtml + '</span>'
                    + '</td>'
                : '<td txdcd=52 style="; text-align:left;padding-left:5px;font-size:15px;border-bottom:1px solid ' + TBC + ';"  otype="' + R.order_type + '" memno="' + row.member_num + '" orderno="' + R.order_member_num + '" >' + howtopayHtml + '</td>';
        }

        // easy 취소수정 상단 버튼
        var easyCancelTop = (String(R.order_call_status) === '1')
            ? '<input type="button" value="취소수정"  class="m5_btn gab" onclick="easyBall_edit(' + num + ',1)">'
            : '<input type="button" value="취소수정"  class="m5_btn gab" onclick="easyBall_edit(' + num + ',1)">'
                + '<input type="button" value="추가발주"  class="m5_btn gab" onclick="easyBall_more(' + num + ',1)">';

        return "<div id='notmatcheddiv'  style='width:100%;margin:0px auto;display:" + row.table_showOK + ";opacity:0.6' isTopDiv='1' rsno='" + num
            + "'  smodeSet='" + row.smodeSet + "' smode='" + row.smode + "' otype='" + row.orsType + "' showmode='" + row.showmode
            + "' data-type='" + row.Sttx + "' id='orderTable_" + row.subTable + "' data_num='" + row.subTable + "'>"
            // eatbtop div 는 원본 뷰에서 테이블·닫기버튼까지 감싼 뒤 맨 끝에 닫힌다 (여기서 닫지 않음).
            + '<div style="width:99%; table-layout:fixed;; border-top:0px solid var(--diary-text-sub);border-bottom:1px solid var(--diary-card-edge); margin:0px auto; padding:1px; margin-bottom:5px;" id="eatbtop_' + num + '" data-type="topEaTable" data_rsno="' + num + '">'
            + progressBar(row, R)
            + '<table width="100%" style="width:100%; table-layout:fixed;; margin:0 auto; text-align:left;border-collapse:collapse" border="0" cellspacing="0" cellpadding="0" class="' + row.ea_ccLast + '"  id="detailShowTr' + row.Sttx + '_' + num + '">'
            + '<colgroup><col width="20%"><col width="60%"><col width="20%"></colgroup>'
            + '<tbody>'
            + '<tr ' + TR_HEIGHT + '>'
            + '<th txdcd=1 align=center style="' + stth + BD_R_XB + ';white-space: nowrap;overflow: hidden;text-overflow: ellipsis" data_xt="1" onclick="' + clickJob + '" isMoreListing="' + row.isMoreListing + '">'
            + "<div dvxd=1 pmdd=\"" + eh(row.bal_contract_pay) + "\" style='width:99%;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;font-size:13px; font-weight:normal' id=\"eaorderstty" + row.Sttx + '_' + num + '">'
            + (row.hasPStIcon ? PST_ICON : '') + ttyHtml
            + '</div>'
            + '<div style="display:none">' + R.order_type + '/' + R.order_status + '</div>'
            + '</th>'
            + '<td txdcd=2 class="td1"  style="font-size:15px; border-bottom:1px solid ' + TBC + ';padding:0px;vertical-align:top;padding-left:5px; padding-top:5px ">'
            + '<div dvxd=2 style="font-size:15px; padding:0px; font-weight:bolder; vertical-align:top;" onclick="' + clickJob + '">'
            + '<span data-type="dateChangeSpan" id="changeDateSpan"  canChangeDateTime="' + ev(row.canChangeDateTime) + '" data-date-lock="' + ev(row.dateLock) + "\" onclick=\"change_dataThing(" + num + ",'" + R.work_time + "',this)\">" + row.date_a + ' <font style="font-size:15px;font-weight:normal">' + row.sstt + '</font> ' + row.date_b + '</span>'
            + ' <font style="font-size:15px;font-weight:normal"><font style=\'font;size:15px;font-weight:normal\'>' + ev(row.workHourStr) + '</font></font>'
            + '</div>'
            + '<div dvxd=3 style="height:10px; padding:0px ; margin:0px;    text-align: center;display:none" id="change_date_' + num + '" data-type="change_Date"></div>'
            + '</td>'
            + '<td txdcd=3 style="' + STT + '" ' + priceBtn + '>'
            + '<div dvxd=4 style="vertical-align:top" adhr="' + R.add_hour + '"  >'
            + priceSpan
            + '</div>'
            + '</td>'
            + '</tr>'
            + '<tr id="Ssetpshowin" style="height:30px;border-bottom:1px solid ' + TBC + '" onclick="' + clickJob + '">'
            + '<th  data_xt="2" style="' + stth + ';' + STYLE_X003 + '" align="center">'
            + "<div dvxd=5 style='width:99%;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;font-size:13px; font-weight:normal' datacd='" + eh(row.TabA_Str) + "' datano='" + num + "' datacx='" + eh(R.direct_type) + "' smode='" + row.smode + "'>"
            + carNumBox + tabAShown
            + '</div>'
            + '</th>'
            + '<td txdcd=499  style="' + (row.jobisdone === 'easy' ? STYLE_X0011 : STYLE_X001) + '" id="orderTapEa_' + num + '" ' + easyCol + ' >'
            + addrCell
            + (row.hasAdrChBtn ? ADR_CH_BTN : '')
            + '</td>'
            + payCell
            + '</tr>'
            + '<tr><td txdcd=7 colspan=3 style="text-align:center; border:none" id="eaLoadingArea_' + num + '"  data_c=5></td></tr>'
            + '<tr style="border-color:var(--diary-surface); display:none" id="easyorderCancelTop_' + num + '" >'
            + '<td colspan=3 style="text-align:center; border-color:var(--diary-surface); padding:5px 0px">'
            + easyCancelTop
            + '</td></tr>'
            + '<tr id="easyorderCancelBox_' + num + '" style="display:none;border-color:var(--diary-surface)">'
            + '<td colspan=3 style="text-align:center; border-color:var(--diary-surface); font-size:20px;font-weight:bolder; color:var(--diary-ink); padding-top:20px">'
            + '오더 취소수정'
            + '<img src="/img/m/_imgcloseit.svg" style="width:35px;height:35px; margin-top:-5px; float:right" onclick="easyBall_edit(' + num + ',2)">'
            + '<div dvxd=8 style="width:100%; height:200px; text-align:center; font-size:20px;font-weight:normal; color:var(--diary-text-faint)">'
            + '<br><br>'
            + '<input type="button" value="취소"  class="m5_btn gab"  style="width:120px; height:40px; border:1px solid var(--diary-accent);-webkit-border-radius:10px;border-radius:10px;background-color:var(--diary-surface); color:var(--diary-accent) " onclick="easyOrderCancelDo(' + num + ')">'
            + '&nbsp;&nbsp;'
            + '<input type="button" value="수정"  class="m5_btn gab"  style="width:120px; height:40px; border:1px solid var(--diary-accent);-webkit-border-radius:10px;border-radius:10px;background-color:var(--diary-accent); color:var(--diary-ink-fixed)" onclick="easyOrderEditDo(' + num + ')">'
            + '<br><br>'
            + '해당 오더를 취소하기 원하면 취소버튼을<br>수정하기 원하면 수정버튼을 클릭해 주세요'
            + '</div><br>'
            + '</td></tr>'
            + '</tbody></table>'
            + "<div dvxd=9 style='width:100%; height:35px ; line-height:35px; font-size:18px; color:var(--diary-ink); background-color:var(--diary-close-bg); text-align:center;display:none; margin-top:10px' data-type=\"btnBotClose\" id=\"TdivClose" + num + "\" onclick=\"closeDetail(" + num + ",'" + row.Sttx + "')\">닫기</div>"
            + '</div></div>'   // eatbtop 닫기 + notmatcheddiv 닫기
            + "<div style='width:100%;height:0px;display:block' id='orderTableGab_" + row.subTable + "''></div>";
    }

    /** rows(배열) → 카드 HTML 연결. */
    function renderList(rows) {
        if (!rows || !rows.length) return '';
        var out = '';
        for (var i = 0; i < rows.length; i++) out += renderCard(rows[i]);
        return out;
    }

    // 작업완료 구분선 (레거시 calendar_sub.php 가 St1↔St2 사이에 echo 하던 것과 동일).
    var DONE_DIVIDER =
        "<div style='width:98%; height:25px;text-align:center; margin-top:0px; background: url(/img/m/line_dot_bg_40.png) left top repeat; border-bottom:1px solid var(--diary-ink); margin:0px auto; padding-top:0px; background-position:50% 50%'>"
        + "<span style='background-color:var(--diary-surface);color:var(--diary-ink);font-size:15px;-webkit-border-radius:10px;border-radius:10px;padding:5px; padding:0px 20px;'>&nbsp;작업 완료된 오더&nbsp;</span>"
        + "</div>";

    /**
     * jsondata 응답({rows, meta}) → 하루치 목록 HTML 봉투.
     * 레거시 _sky_m_05_00_inside_calendar_sub.php(getmode=json)가 내던 것과 동일 구조:
     *   [St1 카드들] + (St1 에 보이는 카드가 있으면) 구분선 + [St2 카드들] + #orderListNums div.
     * DayInfoGetdisplay 가 이 문자열을 그대로 소비한다(#orderListNums·진행바 data_cd 읽음).
     */
    function renderDay(res) {
        if (!res || !res.ok) return '';
        var rows = res.rows || [];
        var meta = res.meta || {};
        var st1 = '', st2 = '', st1Visible = 0;
        for (var i = 0; i < rows.length; i++) {
            var row = rows[i];
            var h = renderCard(row);
            if (row.Sttx === '_St2') {
                st2 += h;
            } else {
                st1 += h;
                if (row.nono === undefined && String(row.showLine) === '1') st1Visible++;
            }
        }
        var divider = st1Visible > 0 ? DONE_DIVIDER : '';
        var nums = (meta.showOrderNumList || []).join(',');
        var oln = "<div style='width:100%; display:none' id='orderListNums'>" + nums + "</div>";
        return st1 + divider + st2 + oln;
    }

    return {
        renderCard: renderCard, renderList: renderList, renderDay: renderDay, _ev: ev,
        progressView: progressView,
    };
});
